import mutations from './mutations.js';
import actions from './actions.js';
import getters from './getters.js';

export default {
    namespaced: true,
    state() {
        return {
            novedades: [{ }],            
            articulos: [],
            proyectos: [],
            testimonios: [{ }],     
            conceptos: [
                {contenido: ''},
                {contenido: ''},
                {contenido: ''}
            ],
            categorias: [],      
            nosotrxs: [],
            espacios: []  ,   
            encuentro: {}, 
            encuentro2022: {}, 
            encuentro2024: {}, 
            encuentro2024vivo: {}, 
            encuentro2024programa: {}, 
            encuentro2026: {}, 
            encuentro2026vivo: {}, 
            encuentro2026programa: {}, 
            declaraciones: {},
            recorrido: {},
            sliderNosotrxs: [
                {
                  id: 0,
                  name: "foto-1",
                  image: '2022/05/20190830_133458-chica-scaled.jpg'
                },
                {
                  id: 1,
                  name: "foto-2",
                  image: '2022/05/20210813_171424-chica-scaled.jpg'
                },
                {
                  id: 2,
                  name: "foto-3",
                  image: '2022/05/20180908_094423-chica-scaled.jpg'
                },
                {
                  id: 3,
                  name: "foto-4",
                  image: '2022/05/20211002_114852.jpg'
                },
                {
                  id: 4,
                  name: "foto-5",
                  image: '2022/05/20190314_182134-scaled.jpg'
                },
                {
                  id: 5,
                  name: "foto-6",
                  image: '2022/05/IMG-20211023-WA0026.jpg'
                },
                {
                  id: 6,
                  name: "foto-7",
                  image: '2022/05/IMG-20211002-WA0076.jpg'
                },
                {
                  id: 7,
                  name: "foto-8",
                  image: '2022/05/IMG-20210814-WA0049.jpg'
                },
                {
                  id: 8,
                  name: "foto-9",
                  image: '2022/05/IMG-20210324-WA0216.jpg'
                },
                {
                  id: 9,
                  name: "foto-10",
                  image: '2022/05/IMG-20200229-WA0022.jpg'
                },
                {
                  id: 10,
                  name: "foto-11",
                  image: '2022/05/IMG-20180921-WA0014.jpg'
                },
                {
                  id: 11,
                  name: "foto-12",
                  image: '2022/05/IMG-20180521-WA0050.jpg'
                },
                {
                  id: 12,
                  name: "foto-13",
                  image: '2022/05/IMG-20170429-WA0065.jpg'
                },
                {
                  id: 13,
                  name: "foto-14",
                  image: '2022/05/IMG-20170429-WA0032.jpg'
                }        
            ],
            ludiculas: [],
            ludCategorias: [],
            ludFiltrosCategorias: [],
            ludCategoriasPadres: [],
            ludCategoriasHijas: [],
            ludCategoriasHijasID: [],
            ludTags: [],
            ludTagsPadres: [],
            ludTagsHijas: [],
            otrosNombres: [],
            ludFiltrosTags: [],
        }
    },
    mutations,
    actions,
    getters
};